module.exports = __webpack_public_path__ + "static/media/king.4311b4e5.png";